// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fjB1BMWnLx6C2H_RySWH {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
}

.JZzQzW7iOzgUvCdLm1tO {
  display: block;
  margin-bottom: 1rem;
  font-weight: 700;
  white-space: nowrap;
}

.Fu7nbaMS3lt7pemoLPvz {
  margin-top: 1rem;
  font-size: 2.5rem;
}

.FSevpTnEb95qnYNI3yJe {
  word-break: normal;
}

.SGVJEhHtPpWg8ep2J_f0 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  align-items: flex-start;
}

.pVt0h0uRK3ohGQRDFWN_ {
  display: flex;
}

.gaCmL7AgK9E6wjsZKTTW {
  flex-direction: column;
}

.NA6UGTWL4Dz35prJa1O0 {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/FormInputPhoneNumber/FormInputPhoneNumber.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".labelContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n}\n\n.inputLabel {\n  display: block;\n  margin-bottom: 16px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.phone {\n  margin-top: 16px;\n  font-size: 40px;\n}\n\n.countryCode {\n  word-break: normal;\n}\n\n.formInputWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  align-items: flex-start;\n}\n\n.leftLabelPosotion {\n  display: flex;\n}\n\n.topLabelPosition {\n  flex-direction: column;\n}\n\n.phoneInputGroup {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelContainer": `fjB1BMWnLx6C2H_RySWH`,
	"inputLabel": `JZzQzW7iOzgUvCdLm1tO`,
	"phone": `Fu7nbaMS3lt7pemoLPvz`,
	"countryCode": `FSevpTnEb95qnYNI3yJe`,
	"formInputWrapper": `SGVJEhHtPpWg8ep2J_f0`,
	"leftLabelPosotion": `pVt0h0uRK3ohGQRDFWN_`,
	"topLabelPosition": `gaCmL7AgK9E6wjsZKTTW`,
	"phoneInputGroup": `NA6UGTWL4Dz35prJa1O0`
};
export default ___CSS_LOADER_EXPORT___;
